import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

/**
 * Màn chọn tiệm (STORY-921 Q3). Dùng `AuthLayout` như cả cụm auth: nó là một bước trong chuỗi
 * đăng nhập chứ không phải một màn bên trong ứng dụng — dùng `MainLayout` thì người dùng thấy
 * thanh điều hướng và tab quầy của một tiệm mà họ CHƯA chọn.
 *
 * `requireAuth`, và nằm ở AuthLayout chứ không MainLayout — cả việc của nó là đặt ra tiệm. Chọn xong
 * thì nạp lại cứng vào MainLayout để init quyết đích (TASK-139).
 */
export const storePickerRoutes = {
  name: 'store-picker',
  path: 'store-picker',
  components: {
    default: () => import('./StorePicker.vue'),
    brand: () => import('./StorePickerBrand.vue'),
  },
  meta: {
    i18n,
    requireAuth: true,
    authHeader: { titleKey: 'storePicker.title', subtitleKey: 'storePicker.desc' },
  },
} satisfies RouteRecordRaw;
